import styled from 'styled-components';

export const ParallelPanelsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const VariationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h2 {
    color: #c0c0c0;
    font-size: 24px;
    opacity: 0.4;
    margin: 0;
  }
`;

export const VariationRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 4px;
  background: ${(props) =>
    props.$isSelected
      ? "rgba(255,255,255,0.33)"
      : props.$isCollected
        ? "rgba(255,255,255,0.1)"
        : "transparent"};
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
`;

export const ParallelColorSwatch = styled.div`
  flex-shrink: 0;
  min-width: 48px;
  min-height: 32px;
  background: ${(props) =>
    `color-mix(in srgb, ${props.$color ?? "#FFFFFF"} 10%, transparent)`};
  border: 1px solid ${(props) => props.$color ?? "#FFFFFF"};
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #FFFFFF;
  flex-shrink: 0;
`;

export const VariationName = styled.p`
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const QtyTickerContainer = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  transition: opacity 0.2s ease;
`;

export const QtyBtn = styled.button`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  width: 34px;
  height: 34px;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.67);
  }
`;

export const QtyLabel = styled.span`
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  color: ${(props) => (props.$active ? "#ffffff" : "rgba(255,255,255,0.35)")};
  cursor: ${(props) => (props.$active ? "pointer" : "default")};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  height: 32px;
  min-width: 96px;
  text-align: center;
  user-select: none;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.67);
  }
`;

export const SerialInputWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 6px;
  transition: opacity 0.2s ease;
`;

export const SerialInput = styled.input`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  box-sizing: border-box;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 500;
  height: 34px;
  outline: none;
  padding: 0 8px;
  text-align: center;
  transition: border-color 0.15s ease, background 0.15s ease;
  width: 52px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }

  &:focus {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.5);
  }

  /* Hide number input spinners */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`;

export const SerialSupplyLabel = styled.span`
  color: rgba(255, 255, 255, 0.45);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
`;
